import Button from "@memorang/ui/src/components/Button";
import DialogWrapper from "@memorang/ui/src/components/DialogWrapper";
import CustomMarkdownRenderer from "components/CustomMarkdownRenderer";
import { Dialog } from "react-native-paper";

const SessionDisclaimerDialog = ({
	visible,
	handleClose,
	text,
	title,
}: {
	visible: boolean;
	handleClose: () => void;
	text: string;
	title: string;
}) => {
	return (
		<DialogWrapper visible={visible} handleClose={handleClose} maxWidth={"xs"}>
			<Dialog.Icon icon="information-outline" />
			<Dialog.Title
				style={{
					textAlign: "center",
				}}
			>
				{title}
			</Dialog.Title>
			<Dialog.Content>
				<CustomMarkdownRenderer text={text} useCustomLink={true} />
			</Dialog.Content>
			<Dialog.Actions>
				<Button
					onPress={handleClose}
					mode="contained"
					style={{
						paddingHorizontal: 16,
					}}
				>
					Got it
				</Button>
			</Dialog.Actions>
		</DialogWrapper>
	);
};

export default SessionDisclaimerDialog;
